import React from 'react'
import ApprovalViewContainer from '../../containers/approvalmng/ApprovalViewContainer'

const ApprovalViewPage = () => {
  return <ApprovalViewContainer/>
}

export default ApprovalViewPage